import AnalyticsClient from './client';
import events from './events';

const analytics = new AnalyticsClient();

export default analytics;
export { events };
